module.exports = __webpack_public_path__ + "static/media/help.4fd7522b.svg";